import type { TFunction } from '@mukil/i18n';
import { FormField, Input } from '@jumpstone/ui-react';
import type {
  EmployeeFormDraft,
  EmployeeFormErrors,
} from './employee_form_validation';

export interface EmployeeNumberFieldProps {
  draft: EmployeeFormDraft;
  errors: EmployeeFormErrors;
  t: TFunction;
  set: <K extends keyof EmployeeFormDraft>(
    key: K,
    value: EmployeeFormDraft[K],
  ) => void;
}

/**
 * The optional employer-assigned employee number (MIGRATION_V395). Unique per
 * organisation when set; a prior-payroll CSV import can match rows by it via
 * the `employee_ref` column. Pure presentation, split out of
 * `employee_form_fields.tsx` to keep that file from growing further. The only
 * client-side rule is the 32-character cap (`too_long`); a duplicate is
 * reported by the server and rendered by the dialog.
 */
export function EmployeeNumberField({
  draft,
  errors,
  t,
  set,
}: EmployeeNumberFieldProps): React.JSX.Element {
  return (
    <FormField
      label={t('employees.form_employee_number')}
      htmlFor="employee-form-employee-number"
      helpText={t('employees.form_employee_number_hint')}
      error={
        errors.employee_number === 'too_long'
          ? t('employees.form_error_too_long')
          : undefined
      }
    >
      <Input
        id="employee-form-employee-number"
        value={draft.employee_number}
        maxLength={32}
        onChange={(e) => {
          set('employee_number', e.target.value);
        }}
      />
    </FormField>
  );
}
